export default __webpack_public_path__ + "static/golden-russet-black-4bb92f0a0a1255a44245af89e023c001.jpg";